module.exports = __webpack_public_path__ + "static/img/ai-banner.6503a1a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ai-banner.jpeg
// module id = CphW
// module chunks = 0